<template>
    <div class="head-nav">
        <div class="w main-nav">
            <swiper :options="swiperOption" ref="mySwiper">
                <swiper-slide
                    v-for="(slide, index) in navList"
                    :key="index"
                    class="text-center font-14 pointer"
                    :class="{'li-active': current == slide.id}">
                    <div style="line-height: 70px" @click="categoryClick(slide)">{{slide.title}}</div>
                </swiper-slide>
                <swiper-slide
                    class="text-center font-14 pointer">
                    <div style="line-height: 70px" @click="moreClick">更多</div>
                </swiper-slide>
            </swiper>
        </div>
    </div>
</template>

<script>
    import 'swiper/swiper-bundle.css'
    import { swiper, swiperSlide } from 'vue-awesome-swiper'

    export default {
        name: 'commonNav',
        data() {
            return {
                current: 1,
                navList: [],
                swiperOption: {
                    slidesPerView: 11,
                    spaceBetween: 20
                }
            }
        },
        watch: {
            '$route': {
                handler(newValue, oldValue) {
                    if (newValue.name !== 'goods-list') {
                        this.current = -1
                    }
                    if (newValue.query.groupId) {
                        this.current = Number(newValue.query.groupId)
                    }
                },
                immediate: true
            }
        },
        components: {
            swiper,
            swiperSlide
        },
        methods: {
            // 获取商品前台分类列表
            getBackstageList() {
                this.ajax({
                    type: 'GET',
                    url: `/category/list/get`,
                    success: (data) => {
                        this.navList = data.data.slice(0, 10)
                        window.sessionStorage.setItem('bannerUrl', this.navList[0].bannerUrl)
                    },
                    error: (err) => {
                        console.log(err)
                    }
                })
            },
            // 进入产品列表接口
            categoryClick(state) {
                this.current = state.id
                window.sessionStorage.setItem('bannerUrl', state.bannerUrl)
                this.$router.push({
                    query: {
                        groupId: state.id,
                        searchTitle: state.title
                    },
                    path: '/list'
                })
            },
            // 点击更多
            moreClick() {
                this.$router.push({
                    query: {
                        condition: true
                    },
                    path: '/activity-list'
                })
            }
        }
    }
</script>
<style>
    .head-nav .w{
        overflow: visible;
    }
    .head-nav .swiper-container{
        position: static !important;
    }
    .head-nav .swiper-wrapper{
        height: 70px;
    }
    .head-nav .swiper-slide{
        height: 68px;
    }
    .main-nav{
        height: 70px;
        color: #222;
        font-size: 16px;
        z-index: 100;
    }
    .li-active{
        color: #a50082;
        border-bottom: 2px solid #a50082;
    }
    .main-nav .category-img{
        width: 40px;
        height: 40px;
        margin: 26px auto 10px;
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/nav/index.vue